import React from 'react';
import InputMask from 'react-input-mask'
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

import MedicationSearch from './MedicationSearch';

const ShortText = ({ question, dispatch }) => {
  const itemControl = question.extension.find((extension) => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl';
  });

  return <>
    <h6 className="card-title">{question.text || 'Enter your question.'}</h6>

    {!itemControl &&
      <input
        onChange={(e) => {
          dispatch(answerQuestion(question, e.target.value))
        }} type="text" className="form-control" />
    }

    {itemControl && itemControl.valueCodeableConcept.coding[0].code === 'phone-number' &&
      <InputMask
        onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
        className="form-control"
        type="text"
        inputMode="numeric"
        mask="999-999-9999"
      />
    }

    {itemControl && itemControl.valueCodeableConcept.coding[0].code === 'medication-search' &&
      <MedicationSearch
        question={question}
        dispatch={(medications) => dispatch(answerQuestion(question, medications))} />
    }
  </>;
}

export default connect()(ShortText);